export type TextFormatType =
  | 'bold'
  | 'underline'
  | 'strikethrough'
  | 'italic'
  | 'code'
  | 'subscript'
  | 'superscript'

// Text node formatting
const IS_BOLD = 1
const IS_ITALIC = 1 << 1
const IS_STRIKETHROUGH = 1 << 2
const IS_UNDERLINE = 1 << 3
const IS_CODE = 1 << 4
const IS_SUBSCRIPT = 1 << 5
const IS_SUPERSCRIPT = 1 << 6

export function getFormats(format: number) {
  return {
    bold: (format & IS_BOLD) !== 0,
    code: (format & IS_CODE) !== 0,
    italic: (format & IS_ITALIC) !== 0,
    strikethrough: (format & IS_STRIKETHROUGH) !== 0,
    subscript: (format & IS_SUBSCRIPT) !== 0,
    superscript: (format & IS_SUPERSCRIPT) !== 0,
    underline: (format & IS_UNDERLINE) !== 0,
  }
}

export type EditorThemeClassName = string
export type TextNodeThemeClasses = {
  base?: EditorThemeClassName
  bold?: EditorThemeClassName
  code?: EditorThemeClassName
  italic?: EditorThemeClassName
  strikethrough?: EditorThemeClassName
  subscript?: EditorThemeClassName
  superscript?: EditorThemeClassName
  underline?: EditorThemeClassName
  underlineStrikethrough?: EditorThemeClassName
}

export type EditorThemeClasses = {
  characterLimit?: EditorThemeClassName
  code?: EditorThemeClassName
  codeHighlight?: Record<string, EditorThemeClassName>
  hashtag?: EditorThemeClassName
  heading?: {
    h1?: EditorThemeClassName
    h2?: EditorThemeClassName
    h3?: EditorThemeClassName
    h4?: EditorThemeClassName
    h5?: EditorThemeClassName
    h6?: EditorThemeClassName
  }
  image?: EditorThemeClassName
  link?: EditorThemeClassName
  list?: {
    ul?: EditorThemeClassName
    ulDepth?: Array<EditorThemeClassName>
    ol?: EditorThemeClassName
    olDepth?: Array<EditorThemeClassName>
    listitem?: EditorThemeClassName
    listitemChecked?: EditorThemeClassName
    listitemUnchecked?: EditorThemeClassName
    nested?: {
      list?: EditorThemeClassName
      listitem?: EditorThemeClassName
    }
  }
  ltr?: EditorThemeClassName
  mark?: EditorThemeClassName
  markOverlap?: EditorThemeClassName
  paragraph?: EditorThemeClassName
  quote?: EditorThemeClassName
  root?: EditorThemeClassName
  rtl?: EditorThemeClassName
  table?: EditorThemeClassName
  tableCell?: EditorThemeClassName
  tableCellHeader?: EditorThemeClassName
  tableRow?: EditorThemeClassName
  text?: TextNodeThemeClasses
  embedBlock?: {
    base?: EditorThemeClassName
    focus?: EditorThemeClassName
  }
  [key: string]: any
}
